import styled from '@/styles';

export const PageShell = styled('div', {
  padding: '24px 24px 100px',
  boxSizing: 'border-box',
  maxWidth: 1200,
  margin: '0 auto',
  width: '100%',
});

export const OrderHeading = styled('p', {
  fontSize: 18,
  fontWeight: 700,
  color: '#1C1C1C',
  margin: '0 0 24px 0',
  fontFamily: "'Manrope', sans-serif",
});

export const TwoColumn = styled('div', {
  display: 'flex',
  gap: 24,
  alignItems: 'flex-start',
});

export const LeftColumn = styled('div', {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: 16,
  minWidth: 0,
});

export const RightColumn = styled('div', {
  width: 448,
  flexShrink: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 24,
});

export const Card = styled('div', {
  background: '#fff',
  border: '1px solid #DADADA',
  borderRadius: 8,
  overflow: 'hidden',
  fontFamily: "'Manrope', sans-serif",
});

export const CardHeader = styled('div', {
  padding: '24px 24px 16px',
});

export const CardTitle = styled('p', {
  fontSize: 16,
  fontWeight: 700,
  color: '#1C1C1C',
  margin: 0,
  fontFamily: "'Manrope', sans-serif",
});

export const JobHeaderRow = styled('div', {
  display: 'flex',
  alignItems: 'flex-start',
  gap: 16,
  padding: 24,
});

export const JobIcon = styled('div', {
  width: 44,
  height: 44,
  borderRadius: 6,
  background: '#F5F5F5',
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: 18,
  fontWeight: 700,
  color: '#5B5B5B',
  overflow: 'hidden',
});

// Skill avatar/icon image used by the review JobCard. Legacy v1 renders
// the skill image via `<Avatar src={skill.imageUrl}>` (see
// `JobCardDetailsRevamped`). v2 falls back to the text-initial badge
// inside `JobIcon` only when the skill has no image_url.
export const JobIconImg = styled('img', {
  width: '100%',
  height: '100%',
  objectFit: 'cover',
});

export const JobMeta = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  minWidth: 0,
});

export const JobName = styled('p', {
  fontSize: 16,
  fontWeight: 700,
  color: '#1C1C1C',
  margin: 0,
  fontFamily: "'Manrope', sans-serif",
});

export const JobMetaText = styled('p', {
  fontSize: 16,
  fontWeight: 400,
  color: '#1C1C1C',
  margin: 0,
  fontFamily: "'Manrope', sans-serif",
  variants: {
    muted: {
      true: { color: '#979797' },
    },
  },
});

export const ScheduleToggleRow = styled('div', {
  borderTop: '1px dashed #DADADA',
  padding: '20px 24px',
});

export const ScheduleToggleInner = styled('button', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  background: 'transparent',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  fontFamily: "'Manrope', sans-serif",
});

export const ScheduleLabel = styled('p', {
  fontSize: 16,
  fontWeight: 700,
  color: '#1C1C1C',
  margin: 0,
  fontFamily: "'Manrope', sans-serif",
});

export const ScheduleAction = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: 6,
  fontSize: 14,
  fontWeight: 600,
  color: '#44A735',
  fontFamily: "'Manrope', sans-serif",
});

export const Chevron = styled('span', {
  display: 'inline-flex',
  transition: 'transform 0.2s',
  variants: {
    open: {
      true: { transform: 'rotate(180deg)' },
    },
  },
});

export const Collapsible = styled('div', {
  variants: {
    open: {
      true: { display: 'block' },
      false: { display: 'none' },
    },
  },
});

export const ScheduleTable = styled('div', {
  padding: '0 24px 12px',
});

export const ScheduleRowsWrap = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  padding: '0 20px',
});

export const ScheduleHeaderRow = styled('div', {
  display: 'flex',
  gap: 16,
  alignItems: 'center',
  padding: '12px 0',
  borderBottom: '1px solid #DADADA',
});

export const ScheduleHeaderCell = styled('span', {
  fontSize: 11,
  fontWeight: 700,
  color: '#979797',
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  fontFamily: "'Manrope', sans-serif",
  variants: {
    col: {
      date: { width: 180, flexShrink: 0 },
      workers: { width: 100, flexShrink: 0 },
      actions: { width: 72, flexShrink: 0 },
    },
  },
});

export const ScheduleHeaderTime = styled('div', {
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  gap: 6,
});

export const ScheduleHeaderTimeLabel = styled('span', {
  fontSize: 11,
  fontWeight: 700,
  color: '#979797',
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  fontFamily: "'Manrope', sans-serif",
});

export const ScheduleHeaderTz = styled('span', {
  fontSize: 11,
  fontWeight: 700,
  background: '#EAF7E7',
  color: '#2E8722',
  borderRadius: 100,
  padding: '2px 8px',
  fontFamily: "'Manrope', sans-serif",
});

export const ScheduleRow = styled('div', {
  display: 'flex',
  gap: 16,
  alignItems: 'flex-start',
  padding: '16px 0',
  borderBottom: '1px solid #DADADA',
  '&:last-child': { borderBottom: 'none' },
});

export const ScheduleDateCell = styled('div', {
  width: 180,
  flexShrink: 0,
  fontSize: 14,
  fontWeight: 600,
  color: '#1C1C1C',
  fontFamily: "'Manrope', sans-serif",
  paddingTop: 2,
});

export const ScheduleTimeCell = styled('div', {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
});

export const ScheduleTimeMain = styled('p', {
  fontSize: 14,
  fontWeight: 700,
  color: '#1C1C1C',
  margin: 0,
  fontFamily: "'Manrope', sans-serif",
});

export const ScheduleTimeSub = styled('p', {
  fontSize: 14,
  fontWeight: 400,
  color: '#1C1C1C',
  margin: 0,
  fontFamily: "'Manrope', sans-serif",
});

export const ScheduleWorkersCell = styled('div', {
  width: 100,
  flexShrink: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  paddingTop: 2,
  fontSize: 14,
  fontWeight: 400,
  color: '#1C1C1C',
  fontFamily: "'Manrope', sans-serif",
});

export const ScheduleActions = styled('div', {
  width: 72,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'flex-start',
  gap: 14,
  paddingTop: 4,
});

export const IconButton = styled('button', {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: 0,
  display: 'flex',
  alignItems: 'center',
  flexShrink: 0,
  color: '#979797',
});

export const RatesSection = styled('div', {
  borderTop: '1px dashed #DADADA',
  paddingBottom: 24,
});

export const KeyValueRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '8px 24px',
  fontFamily: "'Manrope', sans-serif",
});

export const KvLabel = styled('span', {
  fontSize: 16,
  fontWeight: 400,
  color: '#1C1C1C',
  fontFamily: "'Manrope', sans-serif",
});

export const KvValue = styled('span', {
  fontSize: 16,
  fontWeight: 600,
  color: '#1C1C1C',
  fontFamily: "'Manrope', sans-serif",
});

export const RateInputShell = styled('div', {
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  border: '1px solid #DADADA',
  borderRadius: 8,
  background: '#fff',
  height: 38,
  width: 160,
  paddingLeft: 12,
  '&:focus-within': {
    borderColor: '#44A735',
  },
});

export const RateInputDollar = styled('span', {
  fontSize: 14,
  color: '#5B5B5B',
  fontFamily: "'Manrope', sans-serif",
  marginRight: 4,
});

export const RateInput = styled('input', {
  flex: 1,
  height: '100%',
  border: 'none',
  outline: 'none',
  background: 'transparent',
  fontSize: 14,
  color: '#1C1C1C',
  fontFamily: "'Manrope', sans-serif",
  padding: '0 12px 0 0',
  '&:read-only': {
    cursor: 'default',
    color: '#5B5B5B',
  },
});

export const PaymentBody = styled('div', {
  padding: '8px 24px 24px',
});

export const EditOverlay = styled('div', {
  position: 'fixed',
  inset: 0,
  zIndex: 1999,
  background: 'rgba(0, 0, 0, 0.65)',
});

export const EditModal = styled('div', {
  position: 'fixed',
  zIndex: 2000,
  width: 400,
  left: '50%',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  background: '#FEFEFE',
  border: '1px solid #DADADA',
  borderRadius: 8,
  boxShadow: '0px 2px 6px rgba(0,0,0,0.12)',
  display: 'flex',
  flexDirection: 'column',
  fontFamily: "'Manrope', sans-serif",
});

export const EditModalHeader = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  background: '#E7F4E6',
  padding: '16px 20px 20px',
  borderRadius: '8px 8px 0 0',
});

export const EditModalTitle = styled('span', {
  fontSize: 18,
  fontWeight: 700,
  color: '#1C1C1C',
});

export const EditModalBody = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  gap: 14,
  padding: 20,
});

export const EditFieldRow = styled('div', {
  display: 'grid',
  gridTemplateColumns: '80px 1fr',
  alignItems: 'center',
  gap: 16,
});

export const EditFieldLabel = styled('span', {
  fontSize: 15,
  fontWeight: 700,
  color: '#1C1C1C',
});

export const EditInput = styled('input', {
  width: '100%',
  height: 34,
  border: '1px solid #DADADA',
  borderRadius: 8,
  padding: '4px 12px',
  fontSize: 14,
  fontFamily: "'Manrope', sans-serif",
  outline: 'none',
});

export const EditButton = styled('button', {
  background: '#44A735',
  color: 'white',
  border: 'none',
  borderRadius: 8,
  height: 32,
  width: '100%',
  fontWeight: 700,
  fontSize: 12,
  cursor: 'pointer',
});

export const PaymentLabel = styled('p', {
  fontSize: 16,
  fontWeight: 600,
  color: '#44A735',
  margin: 0,
  fontFamily: "'Manrope', sans-serif",
});

export const PaymentMuted = styled('p', {
  fontSize: 14,
  fontWeight: 400,
  color: '#5B5B5B',
  margin: 0,
  fontFamily: "'Manrope', sans-serif",
});

export const AddSkillsButton = styled('button', {
  width: '100%',
  border: '1.5px solid #44A735',
  background: '#fff',
  borderRadius: 8,
  padding: 12,
  fontSize: 14,
  fontWeight: 600,
  color: '#44A735',
  fontFamily: "'Manrope', sans-serif",
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 8,
  boxSizing: 'border-box',
  '&:disabled': {
    opacity: 0.5,
    cursor: 'not-allowed',
  },
});
